import { render, staticRenderFns } from "./SchoolSetup.vue?vue&type=template&id=6e52e450"
import script from "./SchoolSetup.vue?vue&type=script&lang=js"
export * from "./SchoolSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports